// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2H2Tl","rightAdornment":"Header_rightAdornment__56hyV"};